import type { IssuePageSet } from '@pressreader/social-types';

import type { IssuePageSetDto } from '../types';

function mapIssuePageSet(dto: IssuePageSetDto): IssuePageSet {
    const issueKey = dto.issueKey ?? dto.issue ?? '';
    return {
        id: dto.id,
        encryptedOwnerId: dto.encryptedOwnerId,
        issueKey,
        issueId: dto.issueId,
        issueVer: dto.issueVer,
        pages: dto.pages,
    };
}

export { mapIssuePageSet };
